var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgForward(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2599 6.71206C16.6629 6.71206 17.0559 6.83406 17.3879 7.06106L27.5829 14.0241C28.4949 14.6471 28.7299 15.8921 28.1069 16.8041C27.9669 17.0091 27.7889 17.1871 27.5829 17.3271L17.3879 24.2891C16.4759 24.9121 15.2309 24.6781 14.6079 23.7661C14.3819 23.4331 14.2599 23.0401 14.2599 22.6381V21.7631L19.6939 17.5841C19.7859 17.5141 19.8709 17.4361 19.9489 17.3511L20.0599 17.2181C20.7339 16.3431 20.5699 15.0881 19.6949 14.4141L14.2599 10.2341V8.71106C14.2599 7.60706 15.1559 6.71106 16.2599 6.71106V6.71206ZM6.42188 6.71206C6.82487 6.71206 7.21787 6.83406 7.54987 7.06106L17.7449 14.0241C18.6569 14.6471 18.8909 15.8921 18.2679 16.8041C18.1279 17.0091 17.9499 17.1871 17.7449 17.3271L7.54987 24.2891C6.63787 24.9121 5.39288 24.6781 4.76987 23.7661C4.54287 23.4331 4.42188 23.0401 4.42188 22.6381V8.71206C4.42188 7.60806 5.31687 6.71206 6.42188 6.71206Z",
    fill: "url(#hinava_random_uuid_130735204488142798602311423191148601109)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_130735204488142798602311423191148601109",
    x1: 16.4386,
    y1: 6.71106,
    x2: 16.4386,
    y2: 24.6379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForward);
export default __webpack_public_path__ + "static/media/forward.7a2f0ebaa43dacf657dc3381dc183cd4.svg";
export { ForwardRef as ReactComponent };